import { render } from "./WhoWeAre.vue?vue&type=template&id=745c0cb3&ts=true"
import script from "./WhoWeAre.vue?vue&type=script&lang=ts"
export * from "./WhoWeAre.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/otto-tech/otto-financas-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__